module.exports = __webpack_public_path__ + "img/2021_10_dande_pari_1025-3_web.6b6d1d8d.jpg";